// extracted by mini-css-extract-plugin
module.exports = {"titleText":"ArticleDetail_titleText__3w3gF","titleImage":"ArticleDetail_titleImage__3MZ3_"};